import config from '@/utils/config'

/**
 * Constants configuration for APP (maxDocuments, maxPayments, ProviderSatus, invoiceActions ....)
 */
const constants = {
  invoice: {
    factoring: {
      maxPayments: 3,
      maxDocuments: 3,
      mininmumFactoringAmount: config.features.mininmumFactoringAmount
    }
  },
  invoicesAsProviderStatus: {
    send: 'enviadas',
    accepted: 'aceptadas',
    rejected: 'rechazadas'
  },
  invoiceActions: {
    view: 1,
    accept: 2,
    reject: 3,
    history: 4,
    cancel: 5
  },
  popUpInvoiceActions: {
    edit: 'edit',
    send: 'send',
    history: 'history',
    delete: 'delete',
    duplicate: 'duplicate'
  },
  paths: {
    recovery: '/recovery',
    login: '/login'
  },
  promotersCode: {
    BOLE: 2038,
    BORROX: 9908
  }
}

export default constants
